<h1 mat-dialog-title class="text-center dialog-title">TDS Detail</h1>
<div mat-dialog-content>
  <div class="entry-forms">
    <div class="text-end mb-2">
      <button mat-raised-button color="primary" (click)="addTDSRow()">
        <mat-icon>add</mat-icon>
        <span>Add</span>
      </button>
    </div>
    <div class="tabledesign freightdetailtable">
      <table mat-table [dataSource]="this.tdsArray">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>TDS</th>
          <td mat-cell *matCellDef="let row;let i= index;">
            <mat-form-field class="w-160 field-bottom-0 my-2"  appearance="outline">
              <input type="text" matInput readonly  [(ngModel)]="row.wtCode" (click)="onOpenDropDown('TDS',i)">
              <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2" (click)="onOpenDropDown('TDS',i)">
            </mat-form-field>

          </td>
          <td mat-footer-cell *matFooterCellDef class="fw-bold">  </td>
        </ng-container>
        <ng-container matColumnDef="remarks">
          <th mat-header-cell *matHeaderCellDef>Remarks</th>
          <td mat-cell *matCellDef="let row;let i=index;">
            <mat-form-field class="w-160 field-bottom-0 my-2" appearance="outline">
              <input type="text" matInput>
            </mat-form-field>
          </td>
          <td mat-footer-cell *matFooterCellDef class="fw-bold">  </td>
        </ng-container>
        <ng-container matColumnDef="taxCode">
          <th mat-header-cell *matHeaderCellDef>Tax Code</th>
          <td mat-cell *matCellDef="let row;let i=index;">
            <div class="pt-1">
              <mat-form-field class="w-160 field-bottom-0 my-2" appearance="outline">
                <input type="text" matInput readonly>
                <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2">
              </mat-form-field>
            </div>
          </td>
          <td mat-footer-cell *matFooterCellDef class="fw-bold">  </td>
        </ng-container>
        <ng-container matColumnDef="taxSum">
          <th mat-header-cell *matHeaderCellDef>Total Tax Amt</th>
          <td mat-cell *matCellDef="let row;let i=index;">
            <mat-form-field class="w-160 field-bottom-0 my-2" appearance="outline">
              <input type="text" matInput>
            </mat-form-field>
          </td>
          <td mat-footer-cell *matFooterCellDef class="fw-bold"> Total </td>
        </ng-container>
        <ng-container matColumnDef="lineGross">
          <th mat-header-cell *matHeaderCellDef>Net Amount</th>
          <td mat-cell *matCellDef="let row;let i=index;">
            <mat-form-field class="w-160 field-bottom-0 my-2" appearance="outline">
              <input type="text" matInput>
            </mat-form-field>
          </td>
          <td mat-footer-cell *matFooterCellDef class="fw-bold text-end"> 456787 </td>
        </ng-container>'

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row class="tablecard" *matRowDef="let row; columns: displayedColumns;">
          <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
      </table>
    </div>
  </div>
</div>
<div mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close>Cancel</button>
  <button mat-raised-button color="primary" mat-dialog-close (click)="onSave()">Ok</button>
</div>